import React from 'react';
import { getWindowObject } from '@eb/feature-detection';
import { translationPropType } from '@eb/i18n';

export default class PageTitle extends React.PureComponent {
    static propTypes = {
        title: translationPropType.isRequired,
    };

    componentDidMount() {
        this.updateTitle();
    }

    componentDidUpdate() {
        this.updateTitle();
    }

    updateTitle = () => {
        const document = getWindowObject('document');

        if (document) {
            document.title = this.props.title;
        }
    };

    render() {
        return null;
    }
}
